module.exports = __webpack_public_path__ + "img/nella-larsen.0f1196e5.png";